import { InputType } from '@data/types';
import classNames from 'classnames';
import React from 'react';
import { toCamelCase } from 'utilities/helper';

interface Props extends InputType {
  required?: boolean;
}

const Input: React.FC<Props> = ({
  label,
  placeholder,
  type = 'text',
  hideLabel = false,
  className = '',
  required = false,
}) => {
  const classes = 'w-full md:w-1/2 p-4 pb-0 flex flex-col gap-2 text-sm';

  if (hideLabel) {
    return (
      <fieldset className={classNames('', classes, className)}>
        <label htmlFor={toCamelCase(label)} className="min-h-[inherit]">
          <span className="sr-only">{label}</span>
          <input
            id={toCamelCase(label)}
            name={toCamelCase(label)}
            type={type}
            className="border border-solid rounded-md border-grey px-3 py-2 w-full min-h-[inherit]"
            placeholder={placeholder}
            {...(required && { required: true })}
          />
        </label>
      </fieldset>
    );
  }

  return (
    <fieldset className={classNames('', classes, className)}>
      <label htmlFor={toCamelCase(label)} className="text-sm">
        {label} {required && <span className="text-red">*</span>}
      </label>
      <input
        id={toCamelCase(label)}
        name={toCamelCase(label)}
        type={type}
        className="border border-solid rounded-md border-grey p-2 w-full"
        placeholder={placeholder}
        {...(required && { required: true })}
      />
    </fieldset>
  );
};

export default Input;
